/** Format an ISO date string into a short, locale-aware date. */
export function formatDate(value) {
  if (!value) return '—';
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return '—';
  return parsed.toLocaleDateString(undefined, {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
}

const UUID_RE =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/** True when the value looks like a canonical UUID. */
export function isUuid(value) {
  return typeof value === 'string' && UUID_RE.test(value);
}

/** Format an ISO date-time string into a short, locale-aware date + time. */
export function formatDateTime(value) {
  if (!value) return '—';
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return '—';
  return parsed.toLocaleString(undefined, {
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

/** Compact relative time for lifecycle captions (e.g. "38m ago"). */
export function formatRelativeTime(value) {
  if (!value) return '—';
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return '—';
  const deltaSec = Math.round((Date.now() - parsed.getTime()) / 1000);
  const abs = Math.abs(deltaSec);
  if (abs < 60) return 'just now';
  if (abs < 3600) return `${Math.round(abs / 60)}m ago`;
  if (abs < 86400) return `${Math.round(abs / 3600)}h ago`;
  if (abs < 86400 * 7) return `${Math.round(abs / 86400)}d ago`;
  return formatDate(value);
}
